import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {removeFromBoughtCellularPackages, saveToHistory} from '../SelfCareSuccessMsgBlock/SelfCareSuccessMsgBlockSlice';
import UploadFile from '../../Shared/UploadFile/UploadFile';

const NewPricePlanSelfCareBlock = (props) => {
  const [isShowPackage, setIsShowPackage] = useState(false);
  const [packageDetails, setPackageDetails] = useState({});
  const [currPackageIndex, setCurrPackageIndex] = useState(0);

  useEffect(() => {
    setIsShowPackage(false);
    if (props?.data?.boughtCellularPackages && props?.data?.boughtCellularPackages !== null) {
      props.saveToHistory();
      props?.data?.boughtCellularPackages?.map((item, index) => {
        if (item?.subscriberNo === props?.selfCareSlice?.selectedSubscriber?.productSubscriberNo) {
          setPackageDetails(props?.data?.boughtCellularPackages[index]);
          setCurrPackageIndex(index);
          setIsShowPackage(true);
        }
      });
    }
  }, [props?.data?.boughtCellularPackages, props.selfCareSlice.selectedSubscriber]);

  const handleFirstName = () => {
    if (
      !props?.selfCareSlice?.selectedSubscriber?.productFirstName ||
      props?.selfCareSlice?.selectedSubscriber?.productFirstName?.length === 0
    ) {
      return props?.selfCareSlice?.selectedSubscriber?.productSubscriberNo;
    } else {
      return props?.selfCareSlice?.selectedSubscriber?.productFirstName;
    }
  };

  return (
    <>
      {isShowPackage && (
        <div className='new-price-plan-container'>
          <div
            className='close-icon'
            onClick={() => {
              props.removeFromBoughtCellularPackages(currPackageIndex);
              setIsShowPackage(false);
            }}></div>
          <svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M60 105.8c-25.252 0-45.8-20.548-45.8-45.8S34.748 14.2 60 14.2s45.8 20.548 45.8 45.8-20.548 45.8-45.8 45.8z'
              stroke='#000'
              stroke-width='4.4'
            />
            <path d='M37 57.267 54.837 75 83 47' stroke='var(--theme-primary, #810ea9)' stroke-width='5' stroke-linecap='round' stroke-linejoin='round' />
          </svg>
          <span className='success-msg-header'>
            בקשתך להחלפת חבילה ל{handleFirstName()}
            <br></br> הושלמה בהצלחה!
          </span>
          {packageDetails?.isBenefitsForSoldiers ? (
            <>
              <p>החבילה תתעדכן בקווים הנבחרים</p>
              {packageDetails?.isImmediateTransitionPlan ? <p>שלך באופן מיידי</p> : <p> שלך במחזור החיוב הבא {packageDetails?.date}</p>}
              <div className='idf-discount-wrapper'>
                <UploadFile
                  phoneNumber={packageDetails?.subscriberNo}
                  text={packageDetails?.fileUpload?.expandedValue?.[0]?.description?.value || ''}
                  codeFile={packageDetails?.fileUpload?.expandedValue?.[0]?.nameFile?.value || ''}
                />
              </div>
            </>
          ) : packageDetails?.isImmediateTransitionPlan ? (
            <div className='date-container'>החבילה תתעדכן באופן מיידי</div>
          ) : (
            <div className='date-container'>
              החבילה תתעדכן במחזור החיוב הבא בתאריך: <b>{packageDetails?.date}</b>
            </div>
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    selfCareSlice: state.selfcarePage,
    data: state.selfCareSuccessMsg,
  };
};

const mapDispatchToProps = {
  removeFromBoughtCellularPackages,
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPricePlanSelfCareBlock);
